<div class="header">
  <div class="d-flex justify-content-between align-items-center">
    <h3>{{ notificationDetails?.eventName }}</h3>
    <div ngbDropdown class="dropdown">
      <button ngbDropdownToggle tabindex="0" class="button button-green">
        {{ 'notification.details.actions' | translate }}
        <span class="material-symbols-outlined">&#xe313;</span>
      </button>
      <ul class="dropdown-menu bg-white border-0 shadow" ngbDropdownMenu>
        @if (this.allowViewTemplate) {
          <li
            ngbDropdownItem
            id="viewAction"
            (click)="viewTemplate()"
            tabindex="0"
            (keydown.enter)="viewTemplate()"
          >
            {{ 'notification.details.viewTemplate' | translate }}
          </li>
        }
        @if (this.allowEditTemplate) {
          <li
            ngbDropdownItem
            id="editAction"
            (click)="viewTemplate()"
            tabindex="0"
            (keydown.enter)="viewTemplate()"
          >
            {{ 'notification.details.editTemplate' | translate }}
          </li>
        }
        <li
          ngbDropdownItem
          id="addEmailAction"
          (click)="openAddEmailModal()"
          tabindex="0"
          (keydown.enter)="openAddEmailModal()"
        >
          {{ 'notification.details.addEmail' | translate }}
        </li>
      </ul>
    </div>
  </div>
  <a class="back-link" (click)="backToNotifications()">
    &lt;&lt;&nbsp;{{ 'common.backTo' | translate }}
    <span id="prev-url-name">{{ 'notification.details.notifications' | translate }}</span>
  </a>
</div>
@if (isLoader()) {
  <app-loader></app-loader>
}
<div class="details-container notification-details">
  <div class="details-column column-1">
    <div class="details-card event-card">
      <div class="details-header">
        <h5>{{ 'notification.details.eventDetails' | translate }}</h5>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'notification.details.eventName' | translate }}</div>
        <div class="row-value">
          {{ notificationDetails?.eventName ? notificationDetails?.eventName : '--' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'notification.details.eventType' | translate }}</div>
        <div class="row-value">
          {{ notificationDetails?.eventType ? notificationDetails?.eventType : '--' }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'notification.details.distributionListCount' | translate }}</div>
        <div class="row-value">
          {{
            notificationDetails?.distributionList?.emailCount
              ? notificationDetails?.distributionList?.emailCount
              : '--'
          }}
        </div>
      </div>
      <div class="detail-row">
        <div class="row-key">{{ 'notification.details.status' | translate }}</div>
        <div class="row-value">
          <label class="slider-with-text">
            <span class="slider-background">{{ 'notification.details.inactive' | translate }}</span>
            <span class="enabled-overlay">{{ 'notification.details.active' | translate }}</span>
            <input
              type="checkbox"
              id="status"
              #statusToggle
              [disabled]="notificationDetails?.isPaused"
              [checked]="
                notificationDetails?.status === 'Active' || notificationDetails?.status === 'Paused'
              "
              (change)="toggleStatus(statusToggle)"
            />
          </label>
        </div>
      </div>
    </div>
    <!-- Table component -->
    <app-table></app-table>
  </div>

  <div class="details-column column-2">
    <div class="details-card description-card">
      <div class="details-header">
        <h5>{{ 'notification.details.eventDescription' | translate }}</h5>
      </div>
      <div class="detail-row">
        {{ notificationDetails?.description ? notificationDetails?.description : '--' }}
      </div>
    </div>
  </div>
</div>

<ng-template #removeEmailCell let-row let-value="value" let-column>
  <div class="delete-email">
    <span
      class="material-symbols-outlined"
      (click)="openRemoveEmailModal(row)"
      tabindex="0"
      (keydown.enter)="openRemoveEmailModal(row)"
    >
      &#xe872;
    </span>
  </div>
</ng-template>

<ng-template #removeEmailModal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'notification.details.removeEmail' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'notification.details.removeEmailMessage' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="button button-clear" (click)="closeModal()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="button button-pink" (click)="removeEmailFromList()">
      {{ 'common.remove' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #noEmailsModal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'notification.noEmails' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'notification.noEmailsMessage' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="button button-clear" (click)="closeModal()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="button button-pink" (click)="openDistributionListModal()">
      {{ 'notification.addEmails' | translate }}
    </button>
  </div>
</ng-template>
